export type SurveysTabKey = "all-surveys";

export type SurveysTab = {
	key: SurveysTabKey;
	title: string;
};

export const SURVEY_MODALS = {
	CREATE_SURVEY: "create-survey",
	SURVEY_LINK: "survey-link",
	DELETE_SURVEY: "delete-survey",
	CLOSE_SURVEY: "close-survey",
	COPY_SURVEY: "copy-survey",
} as const;

export type SurveyModal = (typeof SURVEY_MODALS)[keyof typeof SURVEY_MODALS];

export type SurveyStore = {
	surveyName: string;
	surveysPageTab: SurveysTab;
	modal: SurveyModal | null;
	surveyLink: string;
	surveyId: string;
	setters: {
		setSurveysPageTab: (page: SurveysTab) => void;
		setModal: (modal: SurveyModal | null) => void;
		setSurveyLink: (link: string) => void;
		setSurveyId: (id: string) => void;
		setSurveyName: (name: string) => void;
	};
	actions: {
		resetStore: () => void;
	};
};
